import { Drums } from '@ezchops/drums';
import { notEmpty } from '@ezchops/helpers';
import { colors } from '@mui/material';
import { styled } from '@mui/material/styles';
import React, { useCallback, useMemo, useState } from 'react';
import { ezColors } from '../../mui';
import { DrumKitContext } from './DrumKitContext';
import { DrumName } from './DrumName';
import { Cymbal, Drum, DrumStick, HiHat, OpenHiHat, Pedal, RideBell } from './Elements';
const DrumKitSVGElement = styled('svg')(({ theme }) => {
    const padStyle = {
        '&:click': { cursor: 'pointer' },
        fill: colors.blueGrey[900],
        '&.L': {
            fill: theme.palette.sticking.left.main
        },
        '&.R': {
            fill: theme.palette.sticking.right.main
        },
        '&.active': {
            fill: colors.blueGrey[100]
        }
    };
    return ({
        flexGrow: 1,
        maxWidth: '800px',
        margin: 'auto',
        display: 'block',
        '& g.pad': {
            '& circle': padStyle,
            '& rect': padStyle,
            '& path': padStyle,
        },
        '& g.pedal': {
            '& rect': {
                ...padStyle,
                rx: 8,
                ry: 8
            },
        },
        '& .drumName': {
            fontSize: '0.8rem',
            fontFamily: 'Work Sans',
            color: colors.blueGrey[900],
            pointerEvents: 'none',
            textTransform: 'uppercase',
            userSelect: 'none'
        },
        '& .ride_bell': {
            '& .drumName': {
                color: ezColors.white,
            }
        },
        '& .stick': padStyle
    });
});
export function DrumKit({ className, ...props }) {
    const [actives, setActives] = useState([]);
    const onPadClick = useCallback((note) => {
        setActives(actives => [...actives, note]);
        setTimeout(() => {
            setActives(actives => actives.filter(a => a !== note));
        }, 100);
    }, [setActives]);
    const padClassName = useCallback((note) => {
        const stickingClass = props.sticking?.[note];
        const activeClass = actives.includes(note) ? 'active' : undefined;
        return [stickingClass, activeClass].filter(notEmpty).join(' ');
    }, [props, actives]);
    const context = useMemo(() => ({ className: padClassName, onPadClick }), [padClassName, onPadClick]);
    return React.createElement(DrumKitSVGElement, { viewBox: "-400 50 800 500" },
        React.createElement(DrumKitContext.Provider, { value: context },
            React.createElement(Drum, { id: 'snare', namePosition: "bottom", note: Drums.SNARE, cx: 0, cy: 416.5, r: 57.5 }),
            React.createElement(Drum, { id: 'tom1', namePosition: "top", note: Drums.HIGH_TOM, cx: -65, cy: 265.5, r: 57.5 }),
            React.createElement(Drum, { id: 'tom2', namePosition: "top", note: Drums.MID_TOM, cx: 61, cy: 265.5, r: 57.5 }),
            React.createElement(Drum, { id: 'tom4', namePosition: "right", note: Drums.LOW_TOM, cx: 142, cy: 364.5, r: 57.5 }),
            React.createElement(HiHat, { id: 'hihat', note: Drums.CLOSED_HI_HAT, cx: -146, cy: 364.5, r: 57.5 }),
            React.createElement(OpenHiHat, { id: 'hihat-open', note: Drums.OPEN_HI_HAT, cx: -146, cy: 364.5, r: 57.5 }),
            React.createElement(Cymbal, { id: 'crash', namePosition: "left", note: Drums.CRASH, cx: -223, cy: 183, r: 90 }),
            React.createElement(Cymbal, { id: 'ride', namePosition: "right", note: Drums.RIDE, cx: 223, cy: 183, r: 90 }),
            React.createElement(RideBell, { id: 'ride_bell', note: Drums.RIDE_BELL, cx: 224, cy: 183, r: 37 }),
            React.createElement(Pedal, { id: 'hihat_pedal', namePosition: "left", note: Drums.PEDAL_HI_HAT, x: -106, y: 444, r: 8, width: 30, height: 60 }),
            React.createElement(Pedal, { id: 'kick_pedal', namePosition: "right", note: Drums.KICK, x: 76, y: 444, r: 8, width: 30, height: 60 }),
            React.createElement(DrumStick, { sticking: "L", tip: { x: -302, y: 365 } }),
            React.createElement(DrumName, { ...{ cx: -302, cy: 452, r: 0, position: 'left' }, name: 'Bal kéz' }),
            React.createElement(DrumStick, { sticking: "R", tip: { x: 302, y: 365 } }),
            React.createElement(DrumName, { ...{ cx: 302, cy: 452, r: 0, position: 'right' }, name: 'Jobb kéz' })));
}
//# sourceMappingURL=DrumKit.js.map